import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraEmpresa, drawFooterEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportPDFPresupuestoCliente (presupuesto, empresa) {
      let pdfName = 'presupuesto_cliente_'; 
      pdfName = pdfName.concat(presupuesto.numero.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');
      /* Cantidad de paginas */
      let pages = 1;

      doc.setProperties({
        title: 'Presupuesto',
        subject: 'Presupuesto',		
        author: 'Cervetti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      /* Inicial renglones */
      let positionRenglonesY = 102;
      /* Limite para el salto de página */
      let positionMaxY = 275;
      /* Limite para incluir totales y datos de facturacion */
      // let positionMaxTotalesY = 230;
      let positionMaxTotalesY = 228;
      
      /* Interlineado */
      let interlineadoRubros = 7;
      let interlineadoRenglones = 3;
      let interlineadoTotales = 7;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }
      
      let feeAgencia = presupuesto.feeAgencia;
      let feeAgenciaPremios = presupuesto.feeAgenciaPremios;
      let discriminarFee = presupuesto.discriminarFee;
      let ocultarLeyendaFee = presupuesto.ocultarLeyendaFee;
      let discriminarPjeFinanciacion = presupuesto.discriminarPjeFinanciacion;
      let cotizacion = presupuesto.cotizacion;
      let importeFee = presupuesto.importeFee;
      let importeFeePremios = presupuesto.importeFeePremios;
      let pjeFinanciacion = presupuesto.pjeFinanciacion;
      let importeFinanciacion = presupuesto.importeFinanciacion;
      let importeDescuento = presupuesto.importeDescuento;
      let importeDescuentoRebate = presupuesto.importeDescuentoRebate;
      
      /* El total del presupuesto al cliente no incluye Iva */
      let importeTotal = presupuesto.importeNeto;

      if ((/true/i).test(presupuesto.ivaIncluido)) {
        importeTotal = presupuesto.importeTotal;
      }
      
      let positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName, presupuesto.presupuestoSugerido);

      /* Renglones */
      positionY += 5;

      /* Titulo de los renglones */
      doc.setTextColor(60, 60, 60);
      doc.setFont(fontBoldName, 'bold');
      doc.setFontSize(8);

      let posicionXCantidad = 160;
      let posicionXCotizacion = 200;
      let posicionXCategoria = 0;

      if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
        posicionXCantidad = 140;
        posicionXCotizacion = 165;
        posicionXCategoria = 170;
      }

      doc.text('Trabajo', 10, positionY);
      doc.text('Cantidad', posicionXCantidad, positionY, alignRight);
      doc.text('Cotización', posicionXCotizacion, positionY, alignRight);
      if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
        doc.text('Categoría', posicionXCategoria, positionY);
      }

      let inicial = true;

      for(let key in presupuesto.renglones) {
        const renglon = presupuesto.renglones[key];

        /* Verificamos si entra el titulo de la OT y al menos dos renglones */
        if (positionY + interlineadoRubros + 5 > positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName, presupuesto.presupuestoSugerido);
          
          // positionY = positionRenglonesY;
          positionY += 5;
        } else {
          if (inicial) {
            positionY += 4;
            inicial = false;
          } else {
            positionY += interlineadoRubros;
          }
        }

        doc.setFontSize(7);
        doc.setFont(fontItalicName, 'italic');

        doc.text( `${renglon.rubroTrabajo.trim()} - ${renglon.titulo.trim()}` , 10, positionY);

        doc.setFontSize(7);
        doc.setFont(fontName, 'normal');
        doc.text(this.$options.filters.numero(renglon.cantidad), posicionXCantidad, positionY, alignRight);

        let subtotal = renglon.cotizacion;
        if ((/true/i).test(discriminarFee) == false) {
          subtotal += renglon.importeFeeAgencia;
        }
        if ((/true/i).test(discriminarPjeFinanciacion) == false) {
          subtotal += renglon.importeFinanciacion;
        }
        
        if ((/true/i).test(presupuesto.ivaIncluido)) {
          subtotal = renglon.importeTotal;
        }

        doc.text(this.$options.filters.moneda(subtotal, presupuesto.moneda), posicionXCotizacion, positionY, alignRight);

        if (renglon.importeDescuento != 0) {
          let textLength = this.$options.filters.moneda(subtotal, presupuesto.moneda).length;
          doc.setDrawColor(117, 117, 117); 
          doc.setLineWidth(0.2);
          doc.line(posicionXCotizacion - (textLength * 1.2), positionY - 1, posicionXCotizacion, positionY - 1);
          doc.setTextColor(60, 60, 60);          
        }
        
        if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
          doc.text(renglon.categoriaServicio.trim(), posicionXCategoria, positionY);
        }

        /* Verificamos si tiene descuento a nivel de la orden */
        if (renglon.importeDescuento != 0) {
          positionY += interlineadoRenglones + 1;
          doc.text(this.$options.filters.moneda(subtotal - renglon.importeDescuento, presupuesto.moneda), posicionXCotizacion, positionY, alignRight);

          if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
            doc.text(`Dto. ${this.$options.filters.porcentaje(renglon.pjeDescuento)}`, posicionXCategoria, positionY);
          } else {
            doc.text(`Dto. ${this.$options.filters.porcentaje(renglon.pjeDescuento)}`, posicionXCantidad, positionY, alignRight);
          }
        }

        let lineasDescripcion = renglon.descripcion.split(/\r?\n/g);

        let lineaInicial = true;

        for (let linea = 0; linea < lineasDescripcion.length; linea++) {

          if (positionY + interlineadoRenglones >= positionMaxY) {
            /* Agregamos el footer */
            drawFooterEmpresa(doc, empresa, fontName);

            /* Agregamos una nueva pagina */
            doc.addPage();
            pages++;
            positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName, presupuesto.presupuestoSugerido);
            
            // positionY = positionRenglonesY;
            positionY += 5;

            doc.setFontSize(6);
            doc.setFont(fontItalicName, 'italic');

            doc.text('Continuación ...', 15, positionY);

            doc.setFontSize(7);
            doc.setFont(fontName, 'normal');
    
            positionY += interlineadoRenglones + 2;
          } else {
            if (lineaInicial) {
              positionY += interlineadoRenglones + 1;
              lineaInicial = false;
            } else {
              positionY += interlineadoRenglones;
            }
          }

          let lineaDescripcion = lineasDescripcion[linea];

          /* Quitamos los caracteres no ascii */
          if (lineaDescripcion.length > 150) {
            let lastSpace = lineaDescripcion.substring(0, 150).search(/ [^ ]*$/);
            /* Dividimos la linea en dos */
            doc.text(lineaDescripcion.substring(0, lastSpace).trim(), 15, positionY);
            positionY += interlineadoRenglones;
            doc.text(lineaDescripcion.substring(lastSpace + 1).trim(), 15, positionY);

          } else {
            doc.text(lineaDescripcion, 15, positionY);
          }
        }
      }
  
      doc.setFontSize(9);
      doc.setFont(fontName, 'normal');

      /* Verificamos el tamaño del bloque de totales */
      let totalesLineas = 2;

      if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
        if (presupuesto.categoriasServicio) {
          totalesLineas += presupuesto.categoriasServicio.length;
        }
      }

      if ((/true/i).test(discriminarFee)) {
        totalesLineas += 2;

        if (importeFinanciacion != 0 & (/true/i).test(discriminarPjeFinanciacion)) {
          totalesLineas ++;
        }

        if (importeDescuentoRebate != 0) {
          totalesLineas += 2;
        }

        
        if (importeFeePremios != 0) {
          totalesLineas ++;
        }
      }

      if (importeDescuento != 0) {
        totalesLineas += 2;
      }

      if ((/true/i).test(presupuesto.prontoPagoFeeDiferenciado) 
          && parseFloat(presupuesto.importeNetoProntoPago) != 0) {
        totalesLineas += 5;
      }

      let totalesAltura = totalesLineas * interlineadoTotales;

      /* Definimos la posición inicial del bloque de totales a partir del footer y la altura del bloque*/
      positionMaxTotalesY = 275 - totalesAltura;

      if (positionY >= positionMaxTotalesY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName, presupuesto.presupuestoSugerido);
          // positionY = positionRenglonesY;
          positionY += 5;
      }

      /* Totales  */
      positionY = positionMaxTotalesY;
      doc.line(10, positionMaxTotalesY, 200, positionMaxTotalesY);      
      
      // positionY += interlineadoTotales;

      if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
        if (presupuesto.categoriasServicio) {
          /* Totales por tipo de servicio */
          doc.setFont(fontItalicName, 'italic');

          presupuesto.categoriasServicio.forEach(categoriaServicio => {
            positionY += interlineadoTotales;
            doc.text(`SUBTOTAL - ${categoriaServicio.nombre.trim()}:`, 10, positionY);
            doc.text(this.$options.filters.moneda(categoriaServicio.total, presupuesto.moneda), 200, positionY, alignRight);
            // positionY += interlineadoTotales;
          });          
        }
      }

      if ((/true/i).test(discriminarFee)) {
        /* Validamos si discriminamos el % de financiacion o lo incluimos en la cotización */
        if (!(/true/i).test(discriminarPjeFinanciacion)) {
          cotizacion = presupuesto.cotizacion + presupuesto.importeFinanciacion;
        }

        positionY += interlineadoTotales;
        doc.setFont(fontBoldItalicName, 'bolditalic');
        doc.text('SUBTOTAL:', 10, positionY);
        doc.text(this.$options.filters.moneda(cotizacion, presupuesto.moneda), 200, positionY, alignRight);

        if (importeDescuentoRebate != 0) {
          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          doc.text('Descuento - Rebate', 10, positionY);
          doc.text(this.$options.filters.moneda(importeDescuentoRebate, presupuesto.moneda), 200, positionY, alignRight);

          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          doc.text('SUBTOTAL:', 10, positionY);
          doc.text(this.$options.filters.moneda(cotizacion - importeDescuentoRebate, presupuesto.moneda), 200, positionY, alignRight);
        }

        /* Verificamos si discriminamos el % de financiación */
        if (importeFinanciacion != 0 & (/true/i).test(discriminarPjeFinanciacion)) {
          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          // doc.setFontType('normal');
          doc.text('Financiación ' + this.$options.filters.numero(pjeFinanciacion, 2) + '%', 10, positionY);
          doc.text(this.$options.filters.moneda(importeFinanciacion, presupuesto.moneda), 200, positionY, alignRight);
        }

        positionY += interlineadoTotales;
        doc.setFont(fontBoldItalicName, 'bolditalic');
        // doc.setFontType('normal');
        doc.text('Fee de Agencia ' + this.$options.filters.numero(feeAgencia, 2) + '%', 10, positionY);
        doc.text(this.$options.filters.moneda(importeFee, presupuesto.moneda), 200, positionY, alignRight);

        if (importeFeePremios != 0) {
          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          // doc.setFontType('normal');
          doc.text('Fee de Rubros Diferenciados ' + this.$options.filters.numero(feeAgenciaPremios, 2) + '%', 10, positionY);
          doc.text(this.$options.filters.moneda(importeFeePremios, presupuesto.moneda), 200, positionY, alignRight);
        }
        
        if (importeDescuento != 0) {
          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          doc.text('SUBTOTAL:', 10, positionY);
          doc.text(this.$options.filters.moneda(cotizacion - importeDescuentoRebate + importeFinanciacion + importeFee + importeFeePremios, presupuesto.moneda), 200, positionY, alignRight);

          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          doc.text('Descuento:', 10, positionY);
          doc.text(this.$options.filters.moneda(importeDescuento, presupuesto.moneda), 200, positionY, alignRight);
        }
      } else {
        if (importeDescuento != 0) {
          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          doc.text('SUBTOTAL:', 10, positionY);
          doc.text(this.$options.filters.moneda(importeTotal + importeDescuento, presupuesto.moneda), 200, positionY, alignRight);

          positionY += interlineadoTotales;
          doc.setFont(fontBoldItalicName, 'bolditalic');
          doc.text('Descuento:', 10, positionY);
          doc.text(this.$options.filters.moneda(importeDescuento, presupuesto.moneda), 200, positionY, alignRight);
        }
      }
      
      positionY += interlineadoTotales;
      
      doc.setFont(fontBoldItalicName, 'bolditalic');
      // doc.setFontType('normal');
      if ((/true/i).test(presupuesto.showLeyendaIVA)) {
        doc.text('PRESUPUESTO TOTAL (IVA no incluido):', 10, positionY);
      } else {
        doc.text('PRESUPUESTO TOTAL:', 10, positionY);
      }
      doc.text(this.$options.filters.moneda(importeTotal, presupuesto.moneda), 200, positionY, alignRight);

      /* Si no discriminamos fee, incluimos la leyenda detallando el pje correspondiente */
      if (!(/true/i).test(discriminarFee) && feeAgencia != 0 && !(/true/i).test(ocultarLeyendaFee)) {
        // positionY += interlineadoTotales;
        positionY += 4;

        doc.setFontSize(8);
        doc.setFont(fontItalicName, 'italic');
        doc.text(`El presupuesto incluye un fee de ${this.$options.filters.numero(feeAgencia, 2)}%`, 10, positionY);
        doc.setFontSize(9);
      }

      if ((/true/i).test(presupuesto.ivaIncluido)) {
        positionY += 4;

        doc.setFontSize(8);
        doc.setFont(fontItalicName, 'italic');
        doc.text(`Los valores incluyen un IVA del ${this.$options.filters.numero(presupuesto.pjeIva, 2)}%`, 10, positionY);
        doc.setFontSize(9);
      }

      /* Ordenes con fee diferenciado + Pronto pago */
      if ((/true/i).test(presupuesto.prontoPagoFeeDiferenciado) 
          && parseFloat(presupuesto.importeNetoProntoPago) != 0) {
        positionY += interlineadoTotales;

        doc.line(10, positionY, 200, positionY);

        positionY += interlineadoTotales;

        doc.setFont(fontBoldItalicName, 'bolditalic');
        // doc.setFontType('normal');

        doc.text('INFORMACIÓN IMPORTANTE', 10, positionY);

        doc.setFont(fontBoldItalicName, 'bolditalic');
        // doc.setFontType('normal');
    
        positionY += interlineadoTotales;
        // doc.text('Total de Órdenes con Pronto Pago / Pago Anticipado:', 10, positionY);
        // doc.text(this.$options.filters.moneda(presupuesto.importeNetoProntoPago, presupuesto.moneda), 200, positionY, alignRight);
        doc.text(`Total de Órdenes con Pronto Pago / Pago Anticipado:  ${this.$options.filters.moneda(presupuesto.importeNetoProntoPago, presupuesto.moneda)}`, 10, positionY);

        /* Leyenda */
        positionY += interlineadoTotales;
        doc.setFontSize(8);
        doc.setFont(fontName, 'normal');
        doc.text('Para efectivizar la contratación de estos servicios se requiere obligatoriamente la acreditación en cuenta bancaria de CERVETTI', 10, positionY);
        positionY += 4;
        doc.text('MKT&EVENTOS SAS 10 días hábiles antes de la ejecución. CERVETTI MKT&EVENTOS SAS no se responsabiliza por pérdidas de reserva,', 10, positionY);
        positionY += 4;
        doc.text('cambios de condiciones contractuales o reclamos de consumidores por demoras en los pagos.', 10, positionY);
      }
      
      positionY += 6;

      doc.setFontSize(6);
      doc.setFont(fontName, 'normal');
      doc.text('Presupuesto sujeto a recotización al momento de la confirmación', 10, positionY);

      drawFooterEmpresa(doc, empresa, fontName);

      /* Imprimimos las alternativas */
      presupuesto.renglones.forEach(ordenTrabajo => {
        if (ordenTrabajo.alternativas) {
          if (ordenTrabajo.alternativas.length != 0) {
            pages += drawAlternativa(this, doc, empresa, presupuesto, ordenTrabajo, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName,
              positionRenglonesY, positionMaxY, interlineadoRubros, interlineadoRenglones);
          }
        }
      });

      /* Numeramos las páginas */
      for (let index = pages - 1; index >= 0; index--) {
        doc.setPage(index + 1);
        doc.setFontSize(6);
        doc.setTextColor(0, 0, 0);
        let cadena = new String().concat('Página ', (index + 1).toString(), " de ", pages.toString());
        doc.text(cadena, 10, 286);
      }

      window.open(doc.output("bloburl", { filename: pdfName + '.pdf' } ));

      return;
    },
  }
}

function drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName, 
  presupuestoSugerido = false, tituloAlternativa = '') {

  /* Verificamos si tiene logo asociado */
  let logoAsociado = (empresa.logoWeConnect.trim() != '')? true : false;

  drawCabeceraEmpresa({
    doc, 
    empresa, 
    fontName,
    dark: false,
    logoAsociado
  });
    
  let alignRight = {
    'align': 'right'
  }

    /* Titulo */
  doc.setFont(fontName, 'normal');
  doc.setFontSize(28);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.text('Presupuesto', 70, 20);

  doc.setFontSize(10);
  doc.setFont(fontName, 'normal');
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  
  let positionY = 18;
  if ((/true/i).test(logoAsociado)) {
    positionY = 40;
  }

  let presupuestoNumero = "00000000" + presupuesto.numero;
  presupuestoNumero = presupuestoNumero.substr(presupuestoNumero.length - 8);
  let adicionalNumero = "000" + presupuesto.adicionalNumero;
  adicionalNumero = adicionalNumero.substr(adicionalNumero.length - 3);
  doc.text(`Nº: 0001-${presupuestoNumero}/${adicionalNumero}`, 200, positionY, alignRight);
  
  doc.setTextColor(0, 0, 0);
  positionY += 5;
  doc.text(`Fecha: ${moment(presupuesto.fecha).format('DD/MM/YYYY')}`, 200, positionY, alignRight);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);

  positionY = 57;
  if ((/true/i).test(logoAsociado)) {
    positionY = 65;
  }

  doc.line(10, positionY, 200, positionY);

  /* Datos del cliente */
  doc.setTextColor(60, 60, 60);
  doc.setFontSize(8);
  
  positionY += 5;
  doc.text(`Cliente: ${presupuesto.clienteRazonSocial.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Cond. Fiscal: ${presupuesto.clienteCondicionFiscal.trim()}`, 10, positionY);
  doc.text(`${presupuesto.clienteDocumentoTipo.trim()}: ${presupuesto.clienteDocumentoNumero.trim()}`, 120, positionY);
  positionY += 4;
  doc.text(`Domicilio: ${presupuesto.clienteDireccion.trim()}`, 10, positionY);
  positionY += 4;
  if ((/true/i).test(presupuesto.showLocalidadCliente)) {
    doc.text(`Localidad: ${presupuesto.clienteLocalidad.trim()}`, 10, positionY);
  } else {
    doc.text(`${presupuesto.clienteProvincia.trim()} - ${presupuesto.clientePais.trim()}`, 24, positionY);
  }

  positionY += 6;
  doc.text(`Orden de Compra Nro: ${presupuesto.numeroOrdenCompra.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Requisidor de la PO: ${presupuesto.contacto.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Descripción de la PO: ${presupuesto.descripcionOrdenCompra.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Acción: ${presupuesto.accion.trim()}`, 10, positionY);
  
  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  positionY += 4;
  doc.line(10, positionY, 200, positionY);
  
  if ((/true/i).test(presupuestoSugerido)) {
    doc.setFontSize(20);
    // doc.setTextColor(232, 67, 113);
    doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
    doc.setFont(fontName, 'normal');
    positionY += 9;
    doc.text('PRESUPUESTO SUGERIDO', 54, positionY);

    doc.setDrawColor(151, 148, 149); 
    doc.setLineWidth(0.3);
    positionY += 3;
    doc.line(10, positionY, 200, positionY);

    doc.setFontSize(8);
    doc.setTextColor(60, 60, 60);

  } else if (tituloAlternativa.trim() != '') {    
    doc.setFontSize(20);
    // doc.setTextColor(232, 67, 113);
    doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
    doc.setFont(fontName, 'normal');

    let length = tituloAlternativa.trim().length;
    // La mitad de los caracteres por la cantidad de mm de cada caracter 
    let spaces = parseFloat(length / 2 * 4.5);
    let positionX = 105 - spaces;
    if (positionX < 10) {
      positionX = 10;
    }
    positionY += 9;
    doc.text(tituloAlternativa.trim().substring(0, 43), positionX, positionY);

    doc.setDrawColor(151, 148, 149); 
    doc.setLineWidth(0.3);
    positionY += 3;
    doc.line(10, positionY, 200, positionY);

    doc.setFontSize(8);
    doc.setTextColor(60, 60, 60);
  }

  return positionY;
}

function drawAlternativa(vm, doc, empresa, presupuesto, ordenTrabajo, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName,
  positionRenglonesY, positionMaxY, interlineadoRubros, interlineadoRenglones) {

    /* Formato para alinear numeros a la derecha */
    let alignRight = {
      'align': 'right'
    }

    let discriminarFee = presupuesto.discriminarFee;
    // let ocultarLeyendaFee = presupuesto.ocultarLeyendaFee;
    let discriminarPjeFinanciacion = presupuesto.discriminarPjeFinanciacion;
    
    let pages = 1;
    doc.addPage();

    let positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
      fontName, fontBoldName, fontItalicName, fontBoldItalicName, false, ordenTrabajo.rubroTrabajo.trim());

    positionY += 5;

    // /* Rubro de la orden */
    // doc.setTextColor(60, 60, 60);
    // doc.setFont(fontBoldName, 'bold');
    // doc.text(ordenTrabajo.rubroTrabajo.trim(), 10, positionY);

    // positionY += 5;

    /* Titulo de los renglones */
    doc.setTextColor(60, 60, 60);
    doc.setFont(fontBoldName, 'bold');

    let posicionXCantidad = 160;
    let posicionXCotizacion = 200;
    let posicionXCategoria = 0;

    if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
      posicionXCantidad = 140;
      posicionXCotizacion = 165;
      posicionXCategoria = 170;
    }

    doc.text('Opción', 10, positionY);
    doc.text('Cantidad', posicionXCantidad, positionY, alignRight);
    doc.text('Cotización', posicionXCotizacion, positionY, alignRight);
    if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
      doc.text('Categoría', posicionXCategoria, positionY);
    }
    positionY += 2;
    
    let inicial = true;

    ordenTrabajo.alternativas.forEach(alternativa => {
      /* Verificamos si entra el titulo de la OT y al menos dos renglones */
      if (positionY + 5 > positionMaxY) {
        /* Agregamos el footer */
        drawFooterEmpresa(doc, empresa, fontName);

        /* Agregamos una nueva pagina */
        doc.addPage();
        pages++;
        positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
          fontName, fontBoldName, fontItalicName, fontBoldItalicName, false, ordenTrabajo.rubroTrabajo.trim());
        
        positionY += 5;
      } else {
        if (inicial) {
          positionY += 4;
          inicial = false;
        } else {
          positionY += interlineadoRubros;
        }
      }

      doc.setFontSize(7);
      if ((/true/i).test(alternativa.seleccionada)) {
        // doc.setTextColor(232, 67, 113);
        doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
      } else {
        doc.setTextColor(60, 60, 60);
      }
      doc.setFont(fontItalicName, 'italic');
      doc.text(alternativa.titulo.trim(), 10, positionY);

      doc.setFontSize(7);
      doc.setFont(fontName, 'normal');
      doc.text(vm.$options.filters.numero(alternativa.cantidad), posicionXCantidad, positionY, alignRight);

      let subtotal = alternativa.cotizacion;
      if ((/true/i).test(discriminarFee) == false) {
        subtotal += alternativa.importeFeeAgencia;
      }
      if ((/true/i).test(discriminarPjeFinanciacion) == false) {
        subtotal += alternativa.importeFinanciacion;
      }
      doc.text(vm.$options.filters.moneda(subtotal, presupuesto.moneda), posicionXCotizacion, positionY, alignRight);
      if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
        doc.text(ordenTrabajo.categoriaServicio.trim(), posicionXCategoria, positionY);
      }

      doc.setTextColor(60, 60, 60);
      
      let lineasDescripcion = alternativa.descripcion.split(/\r?\n/g);
      let lineaInicial = true;

      for (let linea = 0; linea < lineasDescripcion.length; linea++) {

        if (positionY + interlineadoRenglones >= positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          positionY = drawCabeceraPresupuestoCliente(doc, empresa, presupuesto, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName, false, ordenTrabajo.rubroTrabajo.trim());
          positionY += 5;

          doc.setFontSize(6);
          doc.setFont(fontItalicName, 'italic');

          doc.text('Continuación ...', 15, positionY);

          doc.setFontSize(7);
          doc.setFont(fontName, 'normal');
  
          positionY += interlineadoRenglones + 2;
        } else {
          if (lineaInicial) {
            positionY += interlineadoRenglones + 1;
            lineaInicial = false;
          } else {
            positionY += interlineadoRenglones;
          }
        }

        if ((/true/i).test(alternativa.seleccionada)) {
          // doc.setTextColor(232, 67, 113);
          doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
        } else {
          doc.setTextColor(60, 60, 60);
        }
  
        let lineaDescripcion = lineasDescripcion[linea];

        /* Quitamos los caracteres no ascii */
        if (lineaDescripcion.length > 150) {
          let lastSpace = lineaDescripcion.substring(0, 150).search(/ [^ ]*$/);
          /* Dividimos la linea en dos */
          doc.text(lineaDescripcion.substring(0, lastSpace).trim(), 15, positionY);
          positionY += interlineadoRenglones;
          doc.text(lineaDescripcion.substring(lastSpace + 1).trim(), 15, positionY);

        } else {
          doc.text(lineaDescripcion, 15, positionY);
        }

        doc.setTextColor(60, 60, 60);
      }
    });

    /* Si no discriminamos fee, incluimos la leyenda detallando el pje correspondiente */
    if ((/true/i).test(discriminarFee)) {
      positionY = 278;
      doc.setFontSize(8);
      // doc.setTextColor(232, 67, 113);
      doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
      doc.setFont(fontItalicName, 'italic');
      doc.text(`Las cotizaciones de las órdenes no incluyen fee de agencia. El mismo se suma al presupuesto sugerido según la alternativa elegida`, 10, positionY);
      doc.setFontSize(9);
      doc.setTextColor(60, 60, 60);
    }

    drawFooterEmpresa(doc, empresa, fontName);

    return pages;
}